import { AfterContentInit, ChangeDetectionStrategy, Component, Input, ViewEncapsulation, OnChanges, SimpleChanges } from '@angular/core'
import { parse } from 'marked'

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-markdown-renderer',
    styleUrls: ['markdown-renderer.scss'],
    templateUrl: 'markdown-renderer.html',
    encapsulation: ViewEncapsulation.None
})
export class MarkdownRendererComponent implements AfterContentInit, OnChanges {
    innerHTML: string
    @Input() text: string

    // Public
    ngAfterContentInit(): void {
        this.setInnerHTML()
    }

    ngOnChanges(): void {
        this.setInnerHTML()
    }

    setInnerHTML() {
        this.innerHTML = parse(this.text) 
    }
}
